// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1B3BU","right":"styles_right__2vkXm"};